const UploadStatus = ({ uploadedDocument }) => {
  return (
    <div
      className={
        uploadedDocument.description === "Address Document" &&
        uploadedDocument.length <= 1
          ? "row align-items-center mt-0"
          : "row align-items-center border-bottom ms-1 px-0 "
      }
      key={uploadedDocument.id}
    >
      <div className="col   my-4">
        <p className="mb-0">
          <small className="text-primary">{uploadedDocument.description}</small>
        </p>
        <small className="text-gray-700">
          {uploadedDocument.description === "Address Document" ? (
            <small className="text-gray-700"></small>
          ) : (
            uploadedDocument.documentKey
          )}
        </small>
      </div>
      <div className="col-auto mt-2">
        <span className="badge rounded-pill bg-success-soft">
          <span className="h6 text-uppercase ">Uploaded</span>
        </span>
      </div>
    </div>
  );
};

export default UploadStatus;
